import React from "react";
import "./Styles/Home2.css";
function Home2() {
  return (
    <>
      <div className="info-cards">
        <div className="card">
          <a className="yellow" href="/tab"><h2>TAB</h2></a>
          <p>Learn about our technical domains</p>
        </div>
        <div className="card highlight">
          <a className="high" href="/achievement"><h2>Achievements</h2></a>
          <p>View our Achievements</p>
        </div>
        <div className="card">
          <a className="yellow" href="/team"><h2>Team</h2></a>
          <p>Know about our Team</p>
        </div>
      </div>
      <section class="events-section">
        <h1>Gallery</h1>
        <h2>Recent Events</h2>
        <div class="events-grid">
          <div class="event-card">
            <img src="/assets/snistschool.webp" alt="Workshop 2" loading="lazy" />
            <div class="event-info">
              <p>Sreenidhi School</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/RV 25 .jpg" alt="Event 1" loading="lazy" />
            <div class="event-info">
              <p>ROBOVEDA 2025</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/workshop1.webp" alt="Workshop 1" loading="lazy" />
            <div class="event-info">
              <p>Drone Workshop</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/workshop2.webp" alt="Workshop 2" loading="lazy" />
            <div class="event-info">
              <p>IOT Workshop</p>
            </div>
          </div>
        </div>
      </section>
      <section class="events-section">
        <h2>Recent Achivements</h2>
        <div class="events-grid">
          <div class="event-card">
            <img src="/assets/snistschool.webp" alt="Workshop 2" loading="lazy" />
            <div class="event-info">
              <p>Sreenidhi School</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/RV 25 .jpg" alt="Event 1" loading="lazy" />
            <div class="event-info">
              <p>ROBOVEDA 2025</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/workshop1.webp" alt="Workshop 1" loading="lazy" />
            <div class="event-info">
              <p>Drone Workshop</p>
            </div>
          </div>
          <div class="event-card">
            <img src="/assets/workshop2.webp" alt="Workshop 2" loading="lazy" />
            <div class="event-info">
              <p>IOT Workshop</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home2;
